<template lang="html">
  <root class="admin-view-order">

    <admin-nav></admin-nav>
    <page-header name="View order" :count="false"></page-header>

    <!-- Data -->
    <div class="container">
      <div class="row">
        <div class="col m6 offset-m3">
          <table class="striped" v-if="_.size(order)">
            <tbody>
              <tr>
                <th>UID</th>
                <td>{{ order.uid }}</td>
              </tr>
              <tr>
                <th>Business</th>
                <td>{{ order.business.name.en }}</td>
              </tr>
              <tr>
                <th>Delivery address</th>
                <td>{{ order.delivery.address }}</td>
              </tr>
              <tr>
                <th>Delivery date</th>
                <td>{{ order.delivery.date + ' ' + order.delivery.day.en }}</td>
              </tr>
              <tr>
                <th>Delivery time</th>
                <td>{{ order.delivery.time }}</td>
              </tr>
              <tr>
                <th>Dishes</th>
                <td>
                  <li v-for="dish in order.dishes">{{ dish.name.en }}</li>
                </td>
              </tr>
              <tr>
                <th>Phone</th>
                <td>+{{ order.phone }}</td>
              </tr>
              <tr>
                <th>Amount</th>
                <td>{{ order.amount }}</td>
              </tr>
              <tr>
                <th>Instant</th>
                <td>{{ order.is_instant ? 'Yes' : "No" }}</td>
              </tr>
              <tr>
                <th>Status</th>
                <td>{{ _.upperFirst(order.status) }}</td>
              </tr>
              <tr>
                <th>Review</th>
                <td v-if="order.review" class="review-label"><span :class="order.review">{{ _.replace(order.review, '-', ' ') }}</span></td>
                <td v-else>N/A</td>
              </tr>
              <tr v-if="order.status == 'rejected'">
                <th>Reject reason</th>
                <td>{{ order.reject_reason }}</td>
              </tr>
              <tr>
                <th>Created at</th>
                <td>{{ new Date(order.timestamp).toLocaleString() }}</td>
              </tr>
            </tbody>
          </table>

          <h3 class="center-align" v-if="_.size(activities)">Activities</h3>
          <table class="striped" v-if="_.size(activities)">
            <tbody>
              <tr>
                <th>Log</th>
                <th>Timestamp</th>
              </tr>
              <tr v-for="activity of activities">
                <td>{{ activity.log }}</td>
                <td>{{ new Date(activity.timestamp).toLocaleString() }}</td>
              </tr>
            </tbody>
          </table>

          <h3 class="center-align" v-if="_.size(chats)">Chats</h3>
          <table class="striped" v-if="_.size(chats)">
            <tbody>
              <tr>
                <th>Sender</th>
                <th>Message</th>
                <th>Timestamp</th>
              </tr>
              <tr v-for="chat of chats">
                <td>{{ chat.is_from_seller ? 'Business owner' : 'Client' }}</td>
                <td>{{ chat.text }}</td>
                <td>{{ new Date(chat.timestamp).toLocaleString() }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <preloader :is-active="!_.size(order)"></preloader>
  </root>
</template>

<script>
import * as firebase from 'firebase'

export default {
  data() {
    return {
      order: {},
      chats: [],
      activities: [],

      userKey: this.$route.params.userKey,
      orderKey: this.$route.params.orderKey,
    }
  },

  methods: {

    // Collect
    collect() {
      firebase.database()
        .ref('orders/' + this.orderKey)
        .once('value')
        .then( orderSnap => {
          let order = orderSnap.val()

          firebase.database()
            .ref('businesses/' + order.business.key)
            .once('value')
            .then( businessSnap => {
              var ratingsSnap = businessSnap.child('ratings')
              var ratings = _.map(ratingsSnap.val(), ratingSnap => ratingSnap)
              var review = _.find(ratings, { order: order.uid })

              orderSnap.child('chats').forEach(chatSnap => {
                this.chats.push(chatSnap.val())
              })

              var reviewLabels = ['N/A', 'good', 'very-good', 'excellent']

              order.business['name'] = businessSnap.val().name
              order.review = review ? reviewLabels[review['rate']] : 0
              this.order = order

              this.collectActivities(orderSnap.key)
            })
        })
    },

    collectActivities(orderKey) {
      firebase.database()
        .ref('order_activities/' + orderKey)
        .once('value')
        .then(activitiesSnap => {
          activitiesSnap.forEach(activitySnap => {
            this.activities.push(activitySnap.val())
          })
        })
    }
  },

  // Mounted
  mounted() {
    this.collect()
  }
}
</script>

<style lang="scss">
.admin-view-order {
  h3 {
    font-weight: bold;
    text-transform: uppercase;
    margin-top: 30px;
  }

  .review-label {
    span {
      padding: 1px 6px;
      border-radius: 2px;
      color: #fff;
    }

    .excellent { background: #6ebf45 }
    .very-good { background: #fbca3c }
    .good { background: #f0903a }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/OrderView.vue